export const CHAT_NOTIFICATION_TYPE = {
  message: {
    unread: 'UNREAD'
  }
};

export const TELEPHONY_NOTIFICATION_TYPE = {};

export const EMAIL_NOTIFICATION_TYPE = {};
